import { render, staticRenderFns } from "./createTemplatePageXD.vue?vue&type=template&id=411b754c&scoped=true"
import script from "./createTemplatePageXD.vue?vue&type=script&lang=js"
export * from "./createTemplatePageXD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "411b754c",
  null
  
)

export default component.exports